import { logout } from '../store/session';
import { store } from '../index';
import { csrfFetch } from './csrfFetch';

// How often to check if the session is still valid (30 seconds)
const CHECK_INTERVAL = 30 * 1000;

// Custom event names for session invalidation
export const SESSION_INVALIDATED_EVENT = 'session-invalidated';
export const SESSION_TIMEOUT_EVENT = 'session-timeout';

let validationIntervalId = null;

// Function to check if the session is still valid
const checkSessionValidity = async () => {
  try {
    const state = store.getState();
    if (state.session && state.session.user) {
      // Get the session ID from localStorage
      const sessionId = localStorage.getItem('sessionId');

      if (!sessionId) {
        // console.warn('No session ID found in localStorage');
        return;
      }

      // console.log('Checking session validity with session ID:', sessionId);

      const response = await csrfFetch('/api/auth/check-session', {
        method: 'GET',
        headers: {
          'X-Session-ID': sessionId
        }
      });

      const data = await response.json();
      // console.log('Session validity check response:', data);

      if (!data.valid) {
        // Stop the validation interval
        stopSessionValidation();

        if (data.timed_out) {
          // Session has timed out due to inactivity
          // console.log('Session timed out due to inactivity:', data.message);

          // Dispatch a custom event for timeout
          const event = new CustomEvent(SESSION_TIMEOUT_EVENT, {
            detail: { message: data.message || 'Your session has timed out due to inactivity.' }
          });
          window.dispatchEvent(event);
        } else {
          // Session has been invalidated by another login
          console.log('Session invalidated by another login:', data.message);

          // Dispatch a custom event to show the modal
          const event = new CustomEvent(SESSION_INVALIDATED_EVENT, {
            detail: { message: data.message || 'Your session has been invalidated because your account was logged in from another device.' }
          });
          window.dispatchEvent(event);
        }

        // Force logout
        store.dispatch(logout());
      }
    }
  } catch (error) {
    // console.error('Error checking session validity:', error);
  }
};

// Function to start session validation
export const startSessionValidation = () => {
  // Clear any existing interval
  if (validationIntervalId) {
    clearInterval(validationIntervalId);
  }

  // Perform an initial check
  checkSessionValidity();

  // Set up interval to check session validity
  validationIntervalId = setInterval(checkSessionValidity, CHECK_INTERVAL);
  // console.log('Started session validation with interval:', CHECK_INTERVAL);

  // Return a cleanup function
  return () => {
    stopSessionValidation();
  };
};

// Function to stop session validation
export const stopSessionValidation = () => {
  if (validationIntervalId) {
    clearInterval(validationIntervalId);
    validationIntervalId = null;
    // console.log('Stopped session validation');
  }
};
